import { CameraModel } from "./../_models/camera.model";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  OnInit,
  ViewChildren,
  QueryList,
  Injectable,
  OnChanges,
} from "@angular/core";
import { VideojsComponent } from "../_shared/videojs/videojs.component";
import { TreeviewService } from "./../_services/treeview.service";
import Swal from "sweetalert2";
import { WebrtcplayerComponent } from "../_shared/webrtc/webrtcplayer/webrtcplayer.component";
import { CameraService } from "../_services";
import { NotifiService } from "../_services/notifi.service";
import { NotifiModel } from "../_models/notifi.model";
import { AppComponent } from "../app.component";
import { LanguageModel } from "../_models/language.model";
import { HlsjsComponent } from "../_shared/hlsjs/hlsjs.component";
declare var $: any;
@Component({
  selector: "app-liveview",
  templateUrl: "./liveview.component.html",
  styleUrls: ["./liveview.component.css"],
})
export class LiveviewComponent implements OnInit, OnChanges {
  @ViewChildren("videojs") videojs: QueryList<VideojsComponent>;
  @ViewChildren("webrtc") webrtc: QueryList<WebrtcplayerComponent>;
  @ViewChildren("videohls") videohls: QueryList<HlsjsComponent>;
  langModel = new LanguageModel();
  listCameraPlaying: CameraModel[] = [];
  listMetaData: String[] = [];
  gridId = "tab2x2";
  gridClass11 = "col-md-6";
  gridLabel = "2x2-tab";
  lstNotifi: NotifiModel[];
  currNotifi: NotifiModel = new NotifiModel();
  //biến lưu camera-id khi fullscreen
  fullscreenCameraId: number | null = null;

  currentGrid = 2; // default 2x2
  gridClass = "grid-2x2";

  grids = [
    { size: 1, label: "1x1" },
    { size: 2, label: "2x2" },
    { size: 3, label: "3x3" },
    { size: 4, label: "4x4" },
  ];
  constructor(
    @Inject(DOCUMENT) private document: any,
    private _cameraService: CameraService,
    private _appComponent: AppComponent,
    private _notifiService: NotifiService
  ) {}
  elem;
  elemCamera;
  //#region lifecycle hooks
  ngOnInit(): void {
    this.getListNotifi();
    this.updateGridClass();
    this.elem = document.getElementsByClassName("tab-content").item(0);
    //chuyển ngữ
    this._appComponent.translate.get("li_notiffi").subscribe((res: string) => {
      this.langModel.title = res;
    });
    this._appComponent.translate.get("li_max_view").subscribe((res: string) => {
      this.langModel.content = res;
    });
  }
  ngOnChanges(): void {
    this.autoSelectGrid();
  }
  //#endregion lifecycle hooks
  //#region hlsjs
  changeGrid(size: number): void {
    this.currentGrid = size;
    this.updateGridClass();
  }
  updateGridClass(): void {
    this.gridClass = `grid-${this.currentGrid}x${this.currentGrid}`;
  }
  autoSelectGrid(): void {
    const count = this.listCameraPlaying?.length || 0;

    if (count > 9) {
      this.changeGrid(4); // 4x4
    } else if (count > 4) {
      this.changeGrid(3); // 3x3
    } else if (count > 1) {
      this.changeGrid(2); // 2x2
    } else {
      this.changeGrid(1); // 1x1
    }
  }
  removeVideo(video: HlsjsComponent) {
    video.camera.state = 0;
    const videoIndex = this.listCameraPlaying.indexOf(video.camera);
    if (videoIndex !== -1) {
      this.listCameraPlaying.splice(videoIndex, 1);
      this.autoSelectGrid();
    }
  }
  removeAllVideos() {
    if (this.videohls.length > 0) {
      this.videohls.forEach((video) => {
        video.camera.state = 0;
      });
    }
    if (this.webrtc.length > 0) {
      this.webrtc.forEach((player) => {
        player.camera.state = 0;
        player.Close();
      });
      this.listCameraPlaying = [] as CameraModel[];
    }
    this.resetListPlaying();
  }
  resetListPlaying(): void {
    this.listCameraPlaying = [] as CameraModel[];
  }
  //#endregion hlsjs
  getListNotifi() {
    this.lstNotifi = [];
    this._notifiService.getListNotifiWeb().subscribe(
      (res) => {
        let data = res;
        data.forEach((element) => {
          if (element.notify == true) {
            this.lstNotifi.push(element);
          }
        });
        if (this.lstNotifi.length > 0) {
          this.lstNotifi.forEach((e) => {
            this.currNotifi = e;
            $("#mNotifiInfo").modal("show");
          });
        }
      },
      (err) => {
        console.log("Lỗi lấy danh sách thông báo: getListNotifi");
      }
    );
  }

  liveView(camera: CameraModel) {
    // for(let i=0;i<9; i++){
    //   camera.state = 1;
    //     this.listCameraPlaying.push(camera);
    // }
    //  this.autoSelectGrid();
    if (this.listCameraPlaying?.length >= 16) {
      Swal.fire(this.langModel.title, this.langModel.content, "warning");
    } else {
      if (!this.listCameraPlaying.find((item) => item.id === camera.id)) {
        camera.state = 1;
        this.listCameraPlaying.push(camera);
        this.autoSelectGrid();
      }
    }
  }
  getInfoMetaData(camera: CameraModel) {
    this._cameraService.getInfoMetaCam(camera.id).subscribe(
      (res) => {
        this.listMetaData = [];
        this.listMetaData.push("Codec: " + res.codecName);
        this.listMetaData.push("Resolution: " + res.width + " x " + res.height);
        this.listMetaData.push("FrameRate: " + res.realFrameRate);
        let bitRate = Math.round(res.variantBitrate / 8192);
        this.listMetaData.push("Bitrate: " + bitRate + "kb");
      },
      (err) => {
        console.log("Lỗi call data getInfoMetaData()");
      }
    );
  }
  cameraTrackById(index, camera: CameraModel) {
    return camera.id;
  }
  deactiveRouter() {
    if (this.webrtc.length > 0) {
      this.webrtc.forEach((player) => {
        player.camera.state = 0;
        player.Close();
      });
      this.listCameraPlaying = [] as CameraModel[];
    }
    if (this.videojs.length > 0) {
      this.videojs.forEach((video) => {
        video.camera.state = 0;
        video.close();
      });
      this.listCameraPlaying = [] as CameraModel[];
    }
    if (this.videohls.length > 0) {
      this.videojs.forEach((video) => {
        video.camera.state = 0;
      });
      this.listCameraPlaying = [] as CameraModel[];
    }
    // if (this.listCameraPlaying.length > 0) {
    //   this.videojs.forEach((video) => {
    //     video.camera.state = 0;
    //     video.close();
    //   });
    //   this.listCameraPlaying = [] as CameraModel[];
    // }
  }
  openFullscreen() {
    this.elem.styl = "height: 100%; display: flex;";
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  fullscreen(camera: HlsjsComponent) {
    this.elemCamera = document.getElementById("camera_" + camera.camera.id);
    this.elemCamera.styl = "height: 100%; display: flex;";
    if (!document.fullscreenElement) {
      this.fullscreenCameraId = camera.camera.id;
      if (this.elemCamera.requestFullscreen) {
        this.elemCamera.requestFullscreen();
      } else if (this.elemCamera.mozRequestFullScreen) {
        /* Firefox */
        this.elemCamera.mozRequestFullScreen();
      } else if (this.elemCamera.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elemCamera.webkitRequestFullscreen();
      } else if (this.elemCamera.msRequestFullscreen) {
        /* IE/Edge */
        this.elemCamera.msRequestFullscreen();
      }
      document.addEventListener(
        "fullscreenchange",
        this.onFullscreenChange.bind(this)
      );
    } else {
      // Đang fullscreen => thoát fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
    }
  }
  onFullscreenChange() {
    if (!document.fullscreenElement) {
      this.fullscreenCameraId = null;
    }
  }
  setZoomIn(videohls: HlsjsComponent) {
    videohls.zoomIn();
  }

  setZoomOut(videohls: HlsjsComponent) {
    videohls.zoomOut();
  }

  Snapshot(videohls: HlsjsComponent) {
    videohls.takeSnapshot();
  }
  //WebRTC
  fullScreenCamera(camera: WebrtcplayerComponent) {
    this.elemCamera = document.getElementById("camera_" + camera.camera.id);
    this.elemCamera.styl = "height: 100%; display: flex;";
    if (this.elemCamera.requestFullscreen) {
      this.elemCamera.requestFullscreen();
    } else if (this.elemCamera.mozRequestFullScreen) {
      /* Firefox */
      this.elemCamera.mozRequestFullScreen();
    } else if (this.elemCamera.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elemCamera.msRequestFullscreen();
    }
  }
  removeCamera(camera: WebrtcplayerComponent) {
    camera.camera.state = 0;
    const videoIndex = this.listCameraPlaying.indexOf(camera.camera);
    camera.Close();
    if (videoIndex !== -1) {
      this.listCameraPlaying.splice(videoIndex, 1);
      this.autoSelectGrid();
    }
  }
  SnapshotCamera(camera: WebrtcplayerComponent) {
    camera.takeSnapshot();
  }
  ReloadCamera(camera: WebrtcplayerComponent) {
    camera.Close();
    camera.player.playRemote();
  }
  CloseNotifi() {
    $("#mNotifiInfo").modal("hide");
    let checked = $("#cbRemind").prop("checked");
    if (checked == true) {
      this._notifiService
        .stopNotifi(this.currNotifi.maintenanceNotificationId)
        .subscribe(
          (res) => {},
          (err) => {
            console.log("Lỗi close notification");
          }
        );
    }
  }
}
